import { render, staticRenderFns } from "./OrganisationCreate.vue?vue&type=template&id=4e50596c&"
import script from "./OrganisationCreate.vue?vue&type=script&lang=ts&"
export * from "./OrganisationCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports